<template>
  <div>
    <base-header v-once></base-header>
    <base-modal title="레이어 팝업 샘" :modal.sync="modal">
      <h1>id : {{detail.id}}</h1>
      <h1>title : <input v-model="detail.title"></h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <h1>aaa</h1>
      <button @click="doSend">제출</button>
    </base-modal>
    <h1 v-text="title"></h1>
    <div>컴포넌트 이름은 [{{ title }}]입니다.</div>
    <span v-html="html"></span>
    <li v-for="item in items" :key="item.id">
      <div :id="item.id" v-on:click="showDetail(item.id)">{{item.title}}</div>
    </li>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div
        slot="no-more"
        style="color: rgb(102, 102, 102); font-size: 14px; padding: 10px 0px;"
      >목록의 끝입니다 :)</div>
    </infinite-loading>
  </div>
</template>
<script>
import BaseModal from "@/components/sample/BaseModal.vue";

import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "Main",
  components: {
    InfiniteLoading,
    BaseModal,
  },
  data() {
    return {
      title: "Main Component",
      html: "<div>---------- 리스트 시작 ----------</div>",
      items: [],
      limit: 0,
      modal: false,
      detail: {},
    };
  }, 
  watch: {
    '$store.state.ui.child'(child, old) {
      console.log('$store.state.ui.child.watch', child, old);
    }
  },
  methods: {
    infiniteHandler($state) {
      var that = this;
      var parameters = {
        offset: this.limit,
        size: 20
      };
      this.$api.sample
        .list(parameters)
        .then(function(list) {
          if (list.length) {
            console.log("Main.vue <infiniteHandler>", list);
            that.items = that.items.concat(list);
            $state.loaded();
            that.limit += 20;

            if (list.length < 20) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showDetail: function(id) {
      console.log(id);
      // this.detail.id = id;
      // this.modal = true;
      console.log(this.$utils);
      this.$utils.nativeIf.outbound.newPage('/notice/detail');
    },
    doSend() {
      console.log(this.detail.title);
      if(this.detail.title == '' || typeof this.detail.title == 'undefined') {
        alert('타이틀을 입력해주세요.');
      } else {
        alert(this.detail.title);
        this.detail = {};
        this.modal = false;
      }
    }
  }
};
</script>